import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { AccountPhoneNumberView } from '../../add-account-phone-numbers/models/account-phone-number-view.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-phone-number-info',
    styleUrls: ['./phone-number-info.component.scss'],
    templateUrl: './phone-number-info.component.html',
    standalone: false
})
export class PhoneNumberInfoComponent {
   @Input() phoneNumber: AccountPhoneNumberView;

   get phoneNumberValue(): string {
      return this.phoneNumber?.phoneNumber ?? '';
   }

   get displayName(): string {
      return this.phoneNumber?.displayName ?? '';
   }
}
